import DialogVisible from '@/app-core/mixins/dialog/dialogVisible'
import AppTypeEnum from '@/app-core/api/enums/AppTypeEnum'
import {mergeDeep} from '@/app-core/lib/utils/object'

export default {
  name      : 'SelectTableDialog',
  components: {},
  mixins    : [DialogVisible],
  props     : {
    items: {
      type   : Array,
      default: () => []
    }
  },
  data() {
    return {}
  },
  computed: {},
  methods : {
    onTableSelected(item) {
      const payload = {
        type  : item.type,
        value : item.value,
        source: this.$t(`Common.QrSourceType.${item.type}.Id`)
      }

      const data = mergeDeep(this.$dataStore.App.Type.QrData, payload)
      this.$sessionStorage.set('t', AppTypeEnum.QR_SCAN_APP)
      this.$sessionStorage.set('d', `GFP${item.type}${item.value}GFP`)
      this.$sessionStorage.set('QRData', data)
      this.$dataStore.App.Type.QrData = data
      this.$dataStore.App.Type.isQRScanApp = true

      this.$emit('qr-data:selected', item)

      this.closeDialog()
    }
  }
}
